/*******************************************************************************
GET CONFIRMATION MODAL SETTINGS
This function determines a confirmation modal functions.
1) If any values were passed in as data attributes, those take precedence over the presets and default options.
2) If a preset name was passed in, then any options that were not set via data attribute are filled in with the preset values.
3) If no preset name was passed in, then the default options are used to fill in any missing options.
*******************************************************************************/

export default function getPresetsConfirmation(options) {

    // All the different options that can be passed in
    const { preset, itemID, title, message, cancelButton, confirmButton, confirmClass, includeBackground } = options;

    if (preset === 'delete-watchlist') {
        return {
            itemID           : itemID || '',
            title            : title || 'Delete Watchlist?',
            message          : message || 'Are you sure you want to delete this watchlist?',
            cancelButton     : cancelButton || 'Cancel',
            confirmButton    : confirmButton || 'Delete',
            confirmClass     : confirmClass || 'delete-watchlist',
            includeBackground: includeBackground || 'Yes',
        };
    }

    if (preset === 'delete-profile') {
        return {
            itemID           : itemID || '',
            title            : title || 'Delete Profile?',
            message          : message || 'Are you sure you want to delete this profile?',
            cancelButton     : cancelButton || 'Cancel',
            confirmButton    : confirmButton || 'Delete',
            confirmClass     : confirmClass || 'delete-profile',
            includeBackground: includeBackground || 'Yes',
        };
    }


    // Default Options
    return {
        itemID           : itemID || '',
        title            : title || 'Are You Sure?',
        message          : message || 'Are you sure you want to do this?',
        cancelButton     : cancelButton || 'No',
        confirmButton    : confirmButton || 'Yes',
        confirmClass     : confirmClass || '',
        includeBackground: includeBackground || 'Yes',
    };
}
